import React from 'react';

import PropTypes from 'prop-types';

import FlagIcon from 'wanderu-flag-icons';
import { localeToLanguage } from 'wanderu-i18n';

import {
    VerticalMenuItem,
    VerticalMenu,
} from '../../MenuTypes';

function VerticalLocaleMenu(props) {
    const {
        countryLocaleConfigs,
        currentLocale,
        onItemClick,
        onToggleMenu,
    } = props;

    const activeLocaleConfig = countryLocaleConfigs.find((config) => config.isActive);

    const renderCountry = (countryLocaleConfig, locale) => {
        const languageCode = localeToLanguage(locale).toUpperCase();
        const countryNameText = countryLocaleConfig.countryName
            + (countryLocaleConfig.locales.length > 1
                ? ` (${languageCode})`
                : '');
        const countryCode = countryLocaleConfig.countryCode;
        const onClick = () => onItemClick(locale);

        const countryFlag = (
            <FlagIcon
                alt={locale}
                code={countryCode}
            />
        );

        return (
            <VerticalMenuItem
                icon={countryFlag}
                isActive={locale === currentLocale}
                key={countryNameText}
                locale={locale}
                onClick={onClick}
            >
                {countryNameText}
            </VerticalMenuItem>
        );
    };

    const flagIcon = (
        <FlagIcon
            alt={`${activeLocaleConfig.countryCode} flag`}
            code={activeLocaleConfig.countryCode}
        />
    );

    return (
        <VerticalMenu
            onToggleMenu={onToggleMenu}
            selectedItemIcon={flagIcon}
            selectedItemText={activeLocaleConfig.countryName}
        >
            {countryLocaleConfigs.map((countryLocaleConfig) => countryLocaleConfig.locales.map(
                (locale) => renderCountry(countryLocaleConfig, locale),
            ))}
        </VerticalMenu>
    );
}

VerticalLocaleMenu.propTypes = {
    countryLocaleConfigs: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentLocale: PropTypes.string.isRequired,
    onItemClick: PropTypes.func,
    onToggleMenu: PropTypes.func,
};

VerticalLocaleMenu.defaultProps = {
    onItemClick() {},
    onToggleMenu() {},
    path: '',
};

export { VerticalLocaleMenu };
export default VerticalLocaleMenu;
